import { __rest } from 'tslib';
import React__default from 'react';
import { SvgIcon24 } from '../svgIcon24.js';

const WarningCloseIcon = (_a) => {
    var others = __rest(_a, []);
    return (React__default.createElement(SvgIcon24, Object.assign({}, others, { title: "icons / nav24 / error" }),
        React__default.createElement("path", { d: "M12,21 C16.9705627,21 21,16.9705627 21,12 C21,7.02943725 16.9705627,3 12,3 C7.02943725,3 3,7.02943725 3,12 C3,16.9705627 7.02943725,21 12,21 Z M12,23 C5.92486775,23 1,18.0751322 1,12 C1,5.92486775 5.92486775,1 12,1 C18.0751322,1 23,5.92486775 23,12 C23,18.0751322 18.0751322,23 12,23 Z", id: "Oval", fillRule: "nonzero" }),
        React__default.createElement("rect", { id: "Rectangle", x: "11", y: "10", width: "2", height: "7", rx: "1" }),
        React__default.createElement("circle", { id: "Oval-2", cx: "12", cy: "8", r: "1" })));
};

export { WarningCloseIcon };
